"use strict";

angular.module("core").component("loginForm", {
    templateUrl: require("./login-form.component.html"),
    controller: function($scope, $cookies, $http, $stateParams, FlashBag, appConfig, UserService, $state) {
        $scope.UserName = ($stateParams.username ? $stateParams.username : "");

        this.login = function() {
            $scope.loginForm.isValidated = true;

            if ($scope.loginForm.$valid) {
                $http({
                    method: "post",
                    url: appConfig.API_SERVER + "/auth/token/",
                    data: {
                        username: $scope.UserName,
                        password: $scope.Password,
                        app: appConfig.APP
                    }
                }).then(function success(response) {
                    $cookies.remove("filters");
                    UserService.persistAuthToken(response);
                }).catch(FlashBag.apiError);

                if (window.cordova && window.cordova.plugins && window.cordova.plugins.Keyboard) {
                    window.cordova.plugins.Keyboard.close();
                }
            }
        };
    },
    bindings: {
        registerRoute: "@",
        hideForgotPassword: "<?",
        hideForgotUsername: "<?",
        hideRegistration: "<?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/login/login-form.component.js
// module id = 539
// module chunks = 0